import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { CustomFormControl } from '../custom-form-control.component';
import { InputType } from '../custom-form-control.models';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss', '../../styles/custom-control.styles.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent extends CustomFormControl implements OnInit, ControlValueAccessor, Validator {
  @Input() label: string;
  @Input() type: InputType = 'text';
  @Input() binary: boolean = true;
  @Input() forceDisable: boolean;

  constructor(inj: Injector) {
    super(inj);
  }

  ngOnInit(): void {
    this.initBase();
  }

  selectedValue: any = null;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.applyDisabledState(isDisabled);
  }

  selectValue(data: any): void {
    this.selectedValue = data.checked;

    this.onChange(this.selectedValue); // Notify Angular Forms
    this.onTouched(); // Mark as touched
  }

  registerOnValidatorChange?(fn: () => void): void {}
}
